import React, { useEffect, useMemo, useState } from "react";
import {
	Alert,
	Col,
	Form,
	Row,
	Spinner,
	Table,
} from "react-bootstrap";
import { lista_tabela_pagamentos_mol } from "../../services/api";

const formatarData = (valor) => {
	if (!valor) return "-";
	const data = new Date(valor);
	return Number.isNaN(data.getTime())
		? valor
		: data.toLocaleString("pt-BR");
};

const formatarValor = (valor) => {
	const numero = Number(valor);
	return Number.isNaN(numero)
		? valor || "-"
		: numero.toLocaleString("pt-BR", {
				style: "currency",
				currency: "BRL",
			});
};

const TabelaPagamentosMol = () => {
	const [pagamentos, setPagamentos] = useState([]);
	const [dataInicial, setDataInicial] = useState("");
	const [dataFinal, setDataFinal] = useState("");
	const [carregando, setCarregando] = useState(true);
	const [erro, setErro] = useState("");

	useEffect(() => {
		let ativo = true;

		const carregarPagamentos = async () => {
			try {
				setCarregando(true);
				const resposta = await lista_tabela_pagamentos_mol();
				const dados = resposta?.data ?? resposta;
				if (ativo) setPagamentos(Array.isArray(dados) ? dados : []);
			} catch (error) {
				if (ativo) setErro("Não foi possível carregar os pagamentos.");
			} finally {
				if (ativo) setCarregando(false);
			}
		};

		carregarPagamentos();
		return () => {
			ativo = false;
		};
	}, []);

	const pagamentosFiltrados = useMemo(() => {
		const inicio = dataInicial ? new Date(`${dataInicial}T00:00:00`) : null;
		const fim = dataFinal ? new Date(`${dataFinal}T23:59:59.999`) : null;

		return pagamentos.filter((pagamento) => {
			const horario = new Date(pagamento.horario);
			if (Number.isNaN(horario.getTime())) return false;
			return (!inicio || horario >= inicio) && (!fim || horario <= fim);
		});
	}, [pagamentos, dataInicial, dataFinal]);

	return (
		<div className="p-3">
			<h5 className="mb-3">Pagamentos MOL</h5>

			<Row className="mb-3 g-3">
				<Col xs={12} md={3}>
					<Form.Label>Data inicial</Form.Label>
					<Form.Control
						type="date"
						value={dataInicial}
						onChange={(event) => setDataInicial(event.target.value)}
					/>
				</Col>
				<Col xs={12} md={3}>
					<Form.Label>Data final</Form.Label>
					<Form.Control
						type="date"
						value={dataFinal}
						onChange={(event) => setDataFinal(event.target.value)}
					/>
				</Col>
			</Row>

			{erro && <Alert variant="danger">{erro}</Alert>}
			{carregando ? (
				<div className="text-center p-4">
					<Spinner animation="border" role="status" />
				</div>
			) : (
				<div style={{ maxHeight: "430px", overflowY: "auto" }}>
					<Table striped bordered hover responsive className="mb-0">
						<thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
							<tr>
								<th>Matrícula</th>
								<th>Horário</th>
								<th>Valor</th>
								<th>Situação</th>
								<th>Atualizado em</th>
							</tr>
						</thead>
						<tbody>
							{pagamentosFiltrados.map((pagamento, indice) => (
								<tr key={`${pagamento.matricula}-${pagamento.horario}-${indice}`}>
									<td>{pagamento.matricula}</td>
									<td>{formatarData(pagamento.horario)}</td>
									<td>{formatarValor(pagamento.value)}</td>
									<td>{pagamento.situacao || "-"}</td>
									<td>{formatarData(pagamento.updated_at)}</td>
								</tr>
							))}
							{!pagamentosFiltrados.length && (
								<tr>
									<td colSpan={5} className="text-center">
										Nenhum pagamento encontrado.
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</div>
			)}
		</div>
	);
};

export default TabelaPagamentosMol;
